<template>
  <div class="search-page">
    <div class="headerWrapper">搜索</div>

    <div class="search-bar">
      <i class="icon iconfont search-icon">&#xe603;</i>
      <input ref="keywordInput" v-model="keyword" class="search-input" placeholder="输入代码/名称" />
      <i v-if="keyword" class="icon iconfont clear-icon" v-tap @tap="clear">&#xe649;</i>
    </div>

    <div v-if="!keywordTrimmed" class="hot">
      <div class="hot-title">热门合约</div>
      <div class="hot-grid">
        <div v-for="(item, index) in hotList" :key="item.targetId" class="hot-item" v-tap @tap="goDetail(item, hotList)">
          <div class="rank">{{ index + 1 }}</div>
          <div class="names">
            <div class="cn">{{ item.targetName }}</div>
            <div class="en">{{ item.targetId }}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="results">
      <div v-if="filteredList.length === 0" class="empty">暂无匹配结果</div>
      <div v-else class="result-list">
        <div v-for="item in filteredList" :key="item.targetId" class="result-item" v-tap @tap="goDetail(item, filteredList)">
          <div class="left">
            <div class="cn">
              <span v-for="(p, idx) in item.nameParts" :key="idx" :class="p.hit ? 'hl' : ''">{{ p.text }}</span>
            </div>
            <div class="en">
              <span>
                <span v-for="(p, idx) in item.idParts" :key="idx" :class="p.hit ? 'hl' : ''">{{ p.text }}</span>
              </span>
              <span v-if="isDominantTargetId(item.targetId)" class="dominant-badge">主</span>
            </div>
          </div>
          <div class="actions">
            <span
              class="select-btn"
              :class="isSelectedTargetId(item.targetId) ? 'select-btn-remove' : 'select-btn-add'"
              v-tap
              @tap.stop="toggleSelected(item.targetId)"
            >
              {{ isSelectedTargetId(item.targetId) ? "-自选" : "+自选" }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import art from "../../../static/js/proto/art/Art.js";
import front from "../../../static/js/proto/CtpFront.js";
import model from "../../../static/js/proto/Model.js";
import tmi from "../../../static/js/proto/tmi/Tmi.js";

export default {
  name: "search",
  data() {
    return {
      keyword: "",
      allTargets: [],
      hotList: [],
      dominantSuberId: "search-dominant",
      hotSuberId: "search-hot",
      selectedSuberId: "search-selected",
      hotProductToTargetId: {},
      hotTickByTargetId: {},
      hotTargetSubscribed: {},
      _hotUpdateTimer: null,
    };
  },
  computed: {
    keywordTrimmed() {
      return (this.keyword || "").trim();
    },
    filteredList() {
      var key = this.keywordTrimmed;
      if (!key) return [];
      var needle = key.toLowerCase();
      var results = [];

      var splitHighlight = function (raw) {
        var s = String(raw == null ? "" : raw);
        if (!needle) return [{ text: s, hit: false }];
        var sLower = s.toLowerCase();
        var parts = [];
        var start = 0;
        while (true) {
          var idx = sLower.indexOf(needle, start);
          if (idx === -1) {
            if (start < s.length) parts.push({ text: s.slice(start), hit: false });
            break;
          }
          if (idx > start) parts.push({ text: s.slice(start, idx), hit: false });
          parts.push({ text: s.slice(idx, idx + key.length), hit: true });
          start = idx + key.length;
        }
        if (parts.length === 0) parts.push({ text: s, hit: false });
        return parts;
      };

      for (var i = 0; i < this.allTargets.length; i++) {
        var t = this.allTargets[i];
        if (!t || !t.targetId) continue;
        var id = String(t.targetId || "");
        var name = String(t.targetName || "");
        var productName = String(t.productName || "");
        var exchangeName = String(t.exchangeName || "");
        var idLower = id.toLowerCase();
        var nameLower = name.toLowerCase();
        var productNameLower = productName.toLowerCase();
        var exchangeNameLower = exchangeName.toLowerCase();
        var hit =
          idLower.indexOf(needle) !== -1 ||
          nameLower.indexOf(needle) !== -1 ||
          productNameLower.indexOf(needle) !== -1 ||
          exchangeNameLower.indexOf(needle) !== -1;
        if (!hit) continue;
        results.push({
          targetId: id,
          targetName: name || id,
          productName,
          exchangeName,
          nameParts: splitHighlight(name || id),
          idParts: splitHighlight(id),
        });
      }

      var score = function (r) {
        var idLower2 = (r.targetId || "").toLowerCase();
        var name2 = (r.targetName || "");
        var name2Lower = name2.toLowerCase();
        if (idLower2 === needle) return 0;
        if (idLower2.indexOf(needle) === 0) return 1;
        if (name2Lower.indexOf(needle) === 0) return 2;
        if (idLower2.indexOf(needle) !== -1) return 3;
        if (name2Lower.indexOf(needle) !== -1) return 4;
        return 5;
      };
      results.sort(function (a, b) {
        var sa = score(a);
        var sb = score(b);
        if (sa !== sb) return sa - sb;
        return String(a.targetId || "").localeCompare(String(b.targetId || ""));
      });
      return results.slice(0, 200);
    },
  },
  activated() {
    footerIndex = 4;
    this.$store.commit("selectIndex", 4);
    front.autoMount(art.bind(this, this.load));
  },
  deactivated() {
    this.teardownHot();
    this.teardownSelected();
  },
  methods: {
    isDominantTargetId(targetId) {
      var tid = String(targetId || "");
      if (!tid) return false;
      for (var productId in this.hotProductToTargetId) {
        if (this.hotProductToTargetId[productId] === tid) return true;
      }
      return false;
    },
    isSelectedTargetId(targetId) {
      var tid = String(targetId || "");
      if (!tid) return false;
      var selected = this.$store && this.$store.state ? this.$store.state.targetSelected : null;
      return !!(selected && selected[tid]);
    },
    blurKeywordInput() {
      var el = this.$refs && this.$refs.keywordInput;
      if (el && el.blur) el.blur();
    },
    toggleSelected(targetId) {
      var tid = String(targetId || "");
      if (!tid) return;
      this.blurKeywordInput();
      if (this.isSelectedTargetId(tid)) {
        this.$store.commit("selectRemove", tid);
        front.selectedTargetRemove(tid);
      } else {
        this.$store.commit("selectInsert", tid);
        front.selectedTargetAdd(tid);
      }
    },
    clear() {
      this.keyword = "";
    },
    load(onFail) {
      if (onFail instanceof Function) {
        this.$router.push({ path: "/home/search" });
      }
      this.allTargets = front.targetList || [];
      this.setupHot();
      this.setupSelected(onFail);
    },
    setupHot() {
      this.teardownHot();

      const subDominant = (suberId) => {
        front.dominantTargetSub({
          suberId,
          publish: (target) => this.onDominantTarget(target),
        });
      };

      if (!model.dominantSet) {
        model.dominantSet = front.dominantTargetSub({
          suberId: this.dominantSuberId,
          publish: (target) => this.onDominantTarget(target),
        });
      } else {
        subDominant(this.dominantSuberId);
        Object.keys(model.dominantSet).forEach((targetId) => this.onDominantTarget({ targetId }));
      }
    },
    teardownHot() {
      if (this._hotUpdateTimer) {
        clearTimeout(this._hotUpdateTimer);
        this._hotUpdateTimer = null;
      }
      Object.keys(this.hotTargetSubscribed || {}).forEach((targetId) => {
        if (this.hotTargetSubscribed[targetId]) {
          front.unsubTick(targetId, this.hotSuberId);
        }
      });
      this.hotTargetSubscribed = {};
      this.hotProductToTargetId = {};
      this.hotTickByTargetId = {};
      this.hotList = [];
      front.dominantTargetUnsub(this.dominantSuberId);
    },
    setupSelected(reject) {
      var that = this;
      var publish = function (target) {
        if (!target || !target.targetId) return;
        if (target.stamp == art.meta.stamp_remove) {
          that.$store.commit("selectRemove", target.targetId);
          return;
        }
        if (target.stamp == art.meta.stamp_clean) {
          that.$store.commit("selectLoad");
          return;
        }
        that.$store.commit("selectInsert", target.targetId);
      };
      if (art.empty(this.$store.state.targetSelected)) {
        var sub = front.selectedTargetSub({
          suberId: this.selectedSuberId,
          publish: publish,
          reject: reject,
        });
        if (sub) this.$store.commit("selectLoad", sub);
        return;
      }
      front.selectedTargetSub({
        suberId: this.selectedSuberId,
        publish: publish,
        reject: reject,
      });
    },
    teardownSelected() {
      front.selectedTargetUnsub(this.selectedSuberId);
    },
    onDominantTarget(target) {
      const targetId = target && target.targetId ? String(target.targetId) : "";
      if (!targetId) return;

      const productId = tmi.productId(targetId);
      const oldTargetId = this.hotProductToTargetId[productId];
      if (oldTargetId && oldTargetId !== targetId) {
        if (this.hotTargetSubscribed[oldTargetId]) {
          front.unsubTick(oldTargetId, this.hotSuberId);
          delete this.hotTargetSubscribed[oldTargetId];
        }
        delete this.hotTickByTargetId[oldTargetId];
      }
      this.hotProductToTargetId[productId] = targetId;

      if (this.hotTargetSubscribed[targetId]) return;
      this.hotTargetSubscribed[targetId] = true;
      front.subTick(targetId, {
        suberId: this.hotSuberId,
        publish: (tick) => this.onHotTick(tick),
      });
    },
    onHotTick(tick) {
      if (!tick || !tick.targetId) return;
      const targetId = String(tick.targetId);
      const volume = Number(tick.volume || 0);
      this.hotTickByTargetId[targetId] = { volume };

      if (this._hotUpdateTimer) return;
      this._hotUpdateTimer = setTimeout(() => {
        this._hotUpdateTimer = null;
        this.updateHotList();
      }, 100);
    },
    updateHotList() {
      const rows = [];
      Object.keys(this.hotTickByTargetId).forEach((targetId) => {
        const target = front.targetSet ? front.targetSet[targetId] : null;
        const volume = (this.hotTickByTargetId[targetId] && this.hotTickByTargetId[targetId].volume) || 0;
        rows.push({
          targetId,
          targetName: target && target.targetName ? target.targetName : targetId,
          volume,
        });
      });
      rows.sort((a, b) => b.volume - a.volume || a.targetId.localeCompare(b.targetId));
      this.hotList = rows.slice(0, 10);
    },
    goDetail(item, list) {
      if (!item || !item.targetId) return;
      const targets = (list || []).map((r) => r && r.targetId).filter(Boolean);
      const targetNameMap = {};
      (list || []).forEach((r) => {
        if (r && r.targetId) targetNameMap[r.targetId] = r.targetName || r.targetId;
      });
      this.$store.commit("marketDetailNavSet", {
        targets,
        targetNameMap,
        index: targets.indexOf(item.targetId),
        dominantList: false,
      });
      this.$router.push({
        path: "/marketDetail/" + item.targetId,
        query: { dominant: "0" },
      });
    },
  },
};
</script>

<style scoped>
.search-page {
  min-height: 100vh;
  background: #1f1f1f;
  padding-bottom: 1.1rem;
}

.headerWrapper {
  background: #1c201f;
  color: #fff;
  font-size: 0.36rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

.search-bar {
  margin: 0.2rem 0.24rem 0.18rem;
  height: 0.74rem;
  border-radius: 0.37rem;
  background: #2a2a2a;
  display: flex;
  align-items: center;
  padding: 0 0.22rem;
  box-sizing: border-box;
}

.search-icon {
  color: #7d7d7d;
  font-size: 0.34rem;
  margin-right: 0.16rem;
}

.clear-icon {
  color: #7d7d7d;
  font-size: 0.34rem;
  margin-left: 0.16rem;
}

.search-input {
  flex: 1;
  height: 0.74rem;
  border: 0;
  outline: none;
  font-size: 0.28rem;
  color: #e8e8e8;
  background: transparent;
}

.search-input::placeholder {
  color: #7d7d7d;
}

.hot-title {
  margin: 0.1rem 0.24rem 0.14rem;
  color: #e8e8e8;
  font-size: 0.3rem;
  font-weight: 600;
}

.hot-grid {
  margin: 0 0.24rem;
  background: #1f1f1f;
  border-radius: 0.16rem;
  padding: 0.08rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 0.16rem;
  grid-row-gap: 0.16rem;
  box-sizing: border-box;
}

.hot-item {
  display: flex;
  align-items: center;
  padding: 0.14rem 0.12rem;
  border-radius: 0.12rem;
  background: #2a2a2a;
  box-sizing: border-box;
}

.rank {
  width: 0.44rem;
  height: 0.44rem;
  line-height: 0.44rem;
  text-align: center;
  border-radius: 0.1rem;
  background: #ee3f44;
  color: #fff;
  font-size: 0.26rem;
  margin-right: 0.14rem;
  flex: 0 0 auto;
}

.names .cn {
  font-size: 0.28rem;
  color: #e8e8e8;
  line-height: 0.32rem;
}

.names .en {
  font-size: 0.22rem;
  color: #a0a0a0;
  line-height: 0.28rem;
  margin-top: 0.06rem;
}

.results {
  margin: 0.04rem 0;
}

.empty {
  margin: 0.4rem 0;
  text-align: center;
  color: #7d7d7d;
  font-size: 0.28rem;
}

.result-list {
  background: #1f1f1f;
}

.result-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.22rem 0.24rem;
  border-bottom: 1px solid #2d2d2d;
}

.result-item .left .cn {
  font-size: 0.3rem;
  color: #e8e8e8;
  line-height: 0.34rem;
}

.result-item .left .en {
  font-size: 0.22rem;
  color: #a0a0a0;
  line-height: 0.28rem;
  margin-top: 0.06rem;
}

.result-item .right {
  color: #7d7d7d;
  font-size: 0.28rem;
}

.actions {
  margin-left: 0.14rem;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}

.select-btn {
  display: inline-block;
  padding: 0 0.18rem;
  height: 0.48rem;
  line-height: 0.48rem;
  border-radius: 0.24rem;
  font-size: 0.24rem;
  border: 1px solid #3a3a3a;
  color: #e8e8e8;
  background: #2a2a2a;
}

.select-btn-add {
  border-color: rgba(38, 162, 255, 0.7);
  color: #26a2ff;
  background: rgba(38, 162, 255, 0.08);
}

.select-btn-remove {
  border-color: rgba(125, 125, 125, 0.9);
  color: #cfcfcf;
  background: rgba(125, 125, 125, 0.12);
}

.dominant-badge {
  display: inline-block;
  margin-left: 0.12rem;
  padding: 0 0.1rem;
  height: 0.28rem;
  line-height: 0.28rem;
  border-radius: 0.06rem;
  background: #ee3f44;
  color: #fff;
  font-size: 0.2rem;
  vertical-align: middle;
}

.hl {
  color: #26a2ff;
}
</style>



// WEBPACK FOOTER //
// src/components/yj/search.vue